import axios from "axios";
import db from "../../database";
import store from "../../store/index";
// import * as socket from "../../socket";

const state = {
  syncTables: [{
      name: "User Master",
      date: "",
    },
    {
      name: "Item Master",
      date: "",
    },
  ],
  last_sync_time: {
    user_master: "",
    setting_master: "",
    session_master: "",
    item_master: "",
  },
  api_token: {
    dumuy_customer: "",
    vendor: "",
    user_id: 0,
  },
};

const prodLimit = 250;

let catalog_data = {
  from_data: 0,
  to_data: prodLimit,
  to_limit: 0,
  total_records: 0,
  no_batch: 0,
  count: 0,
  log_batch: 0,
};

const mutations = {
  setTimeStamp(state, data) {
    state.last_sync_time[data.type] = data.time_stamp;
  },
  setDate(state, data) {
    state.syncTables[data.index].date = data.data;
  },
};

const actions = {
  saveOfflineStoreUser({
    commit,
    rootState
  }) {
    return new Promise((resolve, reject) => {
      db.user.clear();
      let data = {
        api_token: rootState.sessions.user.api_token,
        v_id: rootState.sessions.user.v_id,
        store_id: rootState.sessions.user.store_id,
        vu_id: rootState.sessions.user.vu_id,
        type: "store_user",
        trans_from: "CLOUD_TAB_WEB",
      };
      axios
        .post("/vendor/table-sync", data)
        .then((res) => {
          if (res.data.time_stamp != "") {
            commit("setTimeStamp", {
              type: "user_master",
              time_stamp: res.data.time_stamp,
            });
          }
          db.user.bulkPut(res.data.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveOfflineSession({
    commit,
    rootState
  }) {
    return new Promise((resolve, reject) => {
      // db.session.clear();
      db.transaction("rw", db.session, (async) => {
        db.session
          .orderBy("id")
          .and((filter) => {
            return filter.sync == 1;
          })
          .each(async (item) => {
            if (item != undefined) {
              await db.session.delete(item.id);
            }
          });
      });
      let data = {
        api_token: rootState.sessions.user.api_token,
        v_id: rootState.sessions.user.v_id,
        store_id: rootState.sessions.user.store_id,
        vu_id: rootState.sessions.user.vu_id,
        type: "session",
        trans_from: "CLOUD_TAB_WEB",
      };
      axios
        .post("/vendor/table-sync", data)
        .then((res) => {
          if (res.data.time_stamp != "") {
            commit("setTimeStamp", {
              type: "session_master",
              time_stamp: res.data.time_stamp,
            });
          }
          let sessionData = res.data.data;
          sessionData.forEach((element) => {
            let postData = Object.assign(element, {
              online_session_id: element.id,
              sync: 1,
            });
            db.session.put(postData);
          });
          db.transaction("rw", db.session, async () => {
            await db.session.orderBy("id").each(async (item) => {
              await db.session.update(item.id, {
                vu_id: parseInt(item.vu_id)
              });
            });
          }).then(() => {
            resolve(res);
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveUserWiseSettings({
    commit,
    rootState
  }) {
    return new Promise((resolve, reject) => {
      let data = {
        api_token: rootState.sessions.user.api_token,
        v_id: rootState.sessions.user.v_id,
        store_id: rootState.sessions.user.store_id,
        vu_id: rootState.sessions.user.vu_id,
        type: "user_wise_settings",
        trans_from: "CLOUD_TAB_WEB",
      };
      axios
        .post("/vendor/table-sync", data)
        .then((res) => {
          db.setting.clear();
          if (res.data.time_stamp != "") {
            commit("setTimeStamp", {
              type: "setting_master",
              time_stamp: res.data.time_stamp,
            });
          }
          db.setting.bulkPut(res.data.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveOfflineStoreProducts({
    commit,
    dispatch,
    rootState
  }, data) {
    return new Promise((resolve, reject) => {
      if (catalog_data.count == 0) {
        store.commit("products/clearProgress");
        catalog_data.count = 1;
        store.commit("system/setSocketConnection", false);
      }

      let data = {
        api_token: rootState.sessions.user.api_token,
        v_id: rootState.sessions.user.v_id,
        store_id: rootState.sessions.user.store_id,
        vu_id: rootState.sessions.user.vu_id,
        trans_from: "CLOUD_TAB_WEB",
        type: "item_master",
        from_record: catalog_data.from_data,
        to_record: catalog_data.to_data,
        total_records: catalog_data.total_records,
        last_page: store.state.products.progress.max != 0 &&
          store.state.products.progress.max -
          store.state.products.progress.current ==
          1 ?
          true : false,
      };
      axios
        .post("/vendor/table-sync", data)
        .then((res) => {
          if (res.data.status == "fail") {
            store.commit("products/sync_error", true);
            rootState.sessions.syncLoading = false;
            store.dispatch("system/log", {
              type: "item_master",
              log: {
                batch: catalog_data.log_batch,
                from: catalog_data.from_data,
                to: catalog_data.to_data,
              },
              status: "error",
            });
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            store.commit("notifications/showAlert", alertData);
            return;
          }
          if (res.data.time_stamp != "") {
            commit("setTimeStamp", {
              type: "item_master",
              time_stamp: res.data.time_stamp,
            });
          }
          if (store.state.products.progress.max == 0) {
            db.products.clear();
            store.commit(
              "products/setProgressMax",
              Math.ceil(res.data.total_no_of_records / catalog_data.to_data)
            );
          }
          if (res.data.total_no_of_records == 0) {
            return (rootState.sessions.syncLoading = false);
          }
          if (catalog_data.total_records == 0) {
            catalog_data.log_batch += 1;
            store.commit("products/setProgressCurrent", catalog_data.log_batch);
            store.dispatch("system/log", {
              type: "item_master",
              log: {
                batch: catalog_data.log_batch,
                from: catalog_data.from_data,
                to: catalog_data.to_data,
              },
              status: "success",
            });
            catalog_data.total_records = res.data.total_no_of_records;
            catalog_data.no_batch =
              Math.ceil(catalog_data.total_records / catalog_data.to_data) - 1;
            catalog_data.to_limit = catalog_data.to_data;
            catalog_data.from_data = catalog_data.to_data;
            catalog_data.to_data = catalog_data.to_data + catalog_data.to_limit;
          } else {
            catalog_data.log_batch += 1;
            store.commit("products/setProgressCurrent", catalog_data.log_batch);
            store.dispatch("system/log", {
              type: "item_master",
              log: {
                batch: catalog_data.log_batch,
                from: catalog_data.from_data,
                to: catalog_data.to_data,
              },
              status: "success",
            });
            catalog_data.from_data = catalog_data.to_data;
            catalog_data.to_data = catalog_data.to_data + catalog_data.to_limit;
            // catalog_data.to_limit = catalog_data.to_data;
            if (catalog_data.no_batch != 0) {
              catalog_data.no_batch -= 1;
            }
          }
          db.products.bulkAdd(res.data.catalog_data);

          if (catalog_data.no_batch == 0) {
            store.commit("system/setSocketConnection", true);
            console.log("Synced");
            catalog_data = {
              from_data: 0,
              to_data: prodLimit,
              to_limit: 0,
              total_records: 0,
              no_batch: 0,
              count: 0,
              log_batch: 0,
            };
            store.commit("products/clearProgress");
            rootState.sessions.syncLoading = false;
            // setTimeout(() => {
            //   socket.getItems();
            // }, 20000);
            resolve(res);
            // alert("synced");
          } else {
            dispatch("saveOfflineStoreProducts");
          }
        })
        .catch((err) => {
          store.commit("products/sync_error", true);
          rootState.sessions.syncLoading = false;
          store.dispatch("system/log", {
            type: "item_master",
            log: {
              batch: catalog_data.log_batch,
              from: catalog_data.from_data,
              to: catalog_data.to_data,
            },
            status: "error",
          });
          reject(err);
        });
    });
  },
  saveOfflineDummyCustomer({
    rootState
  }) {
    if (
      rootState.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
      rootState.system.settings.vendor_app_menu.offline.status == 1
    )
      db.customer.get({
          online_c_id: rootState.billing.billing.dumuy_customer.c_id,
        },
        (c) => {
          if (c == undefined) {
            db.customer.put({
              address: "",
              dob: "",
              email: "",
              first_name: rootState.billing.billing.dumuy_customer.first_name,
              gender: "",
              gst: "",
              online_c_id: rootState.billing.billing.dumuy_customer.c_id,
              mobile: rootState.billing.billing.dumuy_customer.mobile,
              last_name: rootState.billing.billing.dumuy_customer.last_name,
              sync: 1,
              terminal_id: rootState.system.settings.terminal_id,
              session_id: rootState.system.settings.settlement.settlement_session_id,
            });
          }
        }
      );
  },
};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
  catalog_data,
};